"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZPlayerPreferencesSettings = exports.ZPlayerPreferencesEmailSettings = exports.ZPlayerPreferencesEmailSelect = void 0;
const zodSchemas_generated_1 = require("../../generated/zodSchemas.generated");
const zod_1 = require("zod");
exports.ZPlayerPreferencesEmailSelect = zodSchemas_generated_1.zodSelectPlayerPreferences.pick({
    playerId: true,
    agreedToMarketing: true,
    drawReminderEmails: true,
    dprReminders: true,
    notifyResults: true,
    notifyResultsDailyChallenger: true,
    notifyResultsRaffles: true,
    notifyResultsMinilottos: true,
});
exports.ZPlayerPreferencesEmailSettings = zod_1.z.object({
    agreedToMarketing: zod_1.z.boolean().optional(),
    drawReminderEmails: zod_1.z.boolean().optional(),
    dprReminders: zod_1.z.boolean().optional(),
    notifyResults: zod_1.z.boolean().optional(),
    notifyResultsDailyChallenger: zod_1.z.boolean().optional(),
    notifyResultsRaffles: zod_1.z.boolean().optional(),
    notifyResultsMinilottos: zod_1.z.boolean().optional(),
});
exports.ZPlayerPreferencesSettings = exports.ZPlayerPreferencesEmailSettings;
//# sourceMappingURL=models.js.map